export namespace FileUtility {

    export function saveBlob(blob: Blob, filename: string) {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = filename
        a.click()
    }

    export function saveString(s: string, filename: string) {
        let blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), s], {
            type: 'text/csv;charset=utf-8;'
        });

        saveBlob(blob, filename)
    }

}